import * as React from "react"
import * as moment from "moment"
import {ModalComponent} from "./ModalComponent";
import {RadioBtnGroup} from "./common/RadioBtnGroup";
import {default as CTA, CTATheme} from "./common/CallToAction";
import AppUtils from "../utils/AppUtils";
import {ApiManager} from "../api/ApiManager";
import {IConsultationUpdateParams} from "../models/appointment/IConsultationUpdateParams";

interface IMarkDelayModalProps {
    startTimeEpoch: number,
    bookingId: number,
    appointmentId: number,
    patientName: string,
    closeModal: () => void,
    handleSaveSuccess: (delayedInMinutes: number, epoch: number) => void
}

const MarkDelayModal = (props: IMarkDelayModalProps) => {
    const firstOptionMomentObj = moment(props.startTimeEpoch).add(5, "m")
    const secondOptionMomentObj = moment(props.startTimeEpoch).add(10, "m")

    const [isSaving, setIsSaving] = React.useState<boolean>(false)
    const [selectedOption, setSelectOption] = React.useState<number>(null)

    const handleRadioBtnClick = (val: number) => {
        setSelectOption(val)
    }

    const handleSaveClick = () => {
        setIsSaving(true)
        const delayedInMinutes = moment(selectedOption).diff(moment(props.startTimeEpoch), "minutes")
        const consultationUpdateParams: IConsultationUpdateParams = {
            delayedInMinutes
        }
        ApiManager.getAlbusApis().updateAppointment(props.bookingId, props.appointmentId, consultationUpdateParams).then(() => {
            setIsSaving(false)
            props.handleSaveSuccess(delayedInMinutes, selectedOption)
        });
        console.log(consultationUpdateParams)
    }

    return (
        <ModalComponent modalSize={"x-small"} className={"clear-slot-modal mark-delay-modal"}>
            <div className={"clear-slot-header"}>Mark Delay?</div>
            <div className={"clear-slot-subheader"}>
                {`This will postpone your ${moment(props.startTimeEpoch).format("hh:mm")} appointment with ${props.patientName}.`}
            </div>
            <div className={"clear-slot-subheader dark"}>Delay by:</div>
            <RadioBtnGroup items={[
                {displayValue: `By 5 Mins (${firstOptionMomentObj.format("hh:mm")} onwards)`, internalValue: firstOptionMomentObj.valueOf()},
                {displayValue: `By 10 Mins (${secondOptionMomentObj.format("hh:mm")} onwards)`, internalValue: secondOptionMomentObj.valueOf()}
            ]} handleClick={handleRadioBtnClick}/>
            <div className={"clear-slot-cta"}>
                <CTA innerText={"Cancel"} theme={CTATheme.SECONDARY} onClick={props.closeModal}/>
                <CTA innerText={isSaving ? "Saving..." : "Save"} theme={CTATheme.PRIMARY} disabled={!AppUtils.isDefined(selectedOption)} onClick={handleSaveClick}/>
            </div>
        </ModalComponent>
    )
}

export default MarkDelayModal